import { createFileRoute, Navigate } from "@tanstack/react-router";
import { z } from "zod";
import { trpc } from "@/hooks/trpc";
import { HarvestStageId } from "@brewbase/db/types";
import HarvestOperationJournal from "@/features/harvest-journal/operation-journal";
import { useSessionStages } from "@/features/harvest-journal/hooks/use-session-stages";

export const Route = createFileRoute("/harvests/$session_id/stages/$stage_id")({
  component: RouteComponent,
  params: z.object({
    stage_id: z.coerce.number().transform((val) => val as HarvestStageId),
  }),
});

function RouteComponent() {
  const { session_id, stage_id } = Route.useParams();
  const { stages, isLoading } = useSessionStages(session_id);
  const { data: session } = trpc.harvest.getSession.useQuery(session_id);

  const stage = stages.find((s) => s.stageId === stage_id);

  if (isLoading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        Loading...
      </div>
    );
  }

  // A stage the session does not have. Stage ids used to be derived from a
  // step's name and ancestry, so any edit above a stage silently renamed it and
  // every saved link to it stopped resolving; those links land here. The plan is
  // the one page that can orient someone who arrived by a stale address.
  if (!stage) {
    return (
      <Navigate
        to="/harvests/$session_id"
        params={{ session_id } as never}
        replace
      />
    );
  }

  return (
    <HarvestOperationJournal
      sessionId={session_id}
      stage={stage}
      stages={stages}
      isReadOnly={!!session?.ended_at}
    />
  );
}
